'use strict';
const getPixels = require('get-pixels');
let digitreader = require('@smartvatten/digitreader').getDigitReader({runInChildProcess:false});

// Globals
var sourceImageData;

var canvas = null;
var context = null;

var consoleDebug = false;
var debugDiv = null;

function findFromFile(img) {
  return new Promise((resolve, reject) => {
    getPixels(img, function(err, pixels) {
      if (err) { return reject(new Error('Error while getting pixels')) }
      var res = find(pixels);
      if (res === -1) { return reject(new Error('Autoconfig not possible')) }
      return resolve(res);
    })
  });
}

function find(pixels, config2) {
	if (consoleDebug) var startTime = new Date().getTime();
	if (!pixels) return false;
	var config = {
		localContrastW :  8, // Width of local contrast area // was 14
		localContrastMargin : 0.05, // Was 10, // Minimum required deviation from average luminance for active pixel (percentage of average -> 0.1 is 10%)
		minimumSize : 50, // Minimum outline pixel count
		maximumSize :  400, // Maximum outline pixel count
		AABBRatioForDigit1 : 2.0, // Lowest AABB ratio for digit 1
		AABBverticalRatioMin : 1, // Minimum vertical ratio for digit area
		AABBverticalRatioMax : 8, // Maximum vertical ratio for digit area
		invert : false, // invert image (if black background on digits)
		noiseReduction : true, // set to true to enable noise reduction
		maxHeightVariance : 12, // was 8
		neighbourMinDistance : 25,
		neighbourMaxDistance : 60,
		YDisplacementMax : 26
	}

	//canvas needs to be cleared
	//if (!context) canvas = null;
	canvas = null; context = null;

	var width = 640;
	var height = 480;
	var channels = 4;
	var data;

	// Pixel data received - fetch some measurements
	if (pixels.shape) {
		width = pixels.shape[0];
		height = pixels.shape[1];
	}
	var pixelsData = new Uint8ClampedArray(width * height * channels);
	// copy pixels to pixelsData
	for (var i = 0, len = width * height * channels; i < len; i++) {
		pixelsData[i] = pixels.data[i];
	}

	if (typeof document === 'object' && !canvas) {
		canvas = document.createElement('canvas');
		canvas.style.id = "targetCanvas";
		canvas.width  = width;
		canvas.height = height;
		context = canvas.getContext("2d");
		sourceImageData = context.createImageData(width, height);
		data = sourceImageData.data;

		// copy pixels to ImgData
		for (var i = 0, len = width * height * channels; i < len; i++) {
    		data[i] = pixelsData[i];
		}
		// draw original source to canvas
		context.putImageData(sourceImageData, 0, 0);
	} else data = pixelsData;

	var A = [50, 10, width - 50, Math.floor(height * .8)];

	// Create arrays
	var digitObjects = [];
	var eliminatedPixels = [];

	var inverted = 	config.invert;

	var xEnd = A[2],
		yEnd = A[3];

	// CALCULATE LUMINANCE
	for (var y = A[1], r, g, b, lum; y <= yEnd; y++){ // lines
		for (var x = A[0], index; x < xEnd; x++){ // rows
			index = x * channels + y * channels * width; // Position to index
			r = data[index], g = data[index + 1], b = data[index + 2];
			data[index] = (r + r + b + g + g + g) / 6 | 0; // TBD check if this works better without difference between channels

		}
	}


	//if (context) context.putImageData(sourceImageData, 0, 0);
	if (config.noiseReduction) kuwaharaFilter(data, A, width, height, channels, 5);

	localContrastNormalization(inverted, config.localContrastW, data, A, config.localContrastMargin, width, channels);
	//digitDetectionFilter(null, pixels, config2);
	removeHorizontalLines(60, A, data, width, channels);

	var margin = 0.1; // Affects only edges
	reduceNoiseX(data, A, width, channels, margin);
	reduceNoiseY(data, A, width, channels, margin);
	reduceNoiseTiltUp(data, A, width, channels, margin);
	reduceNoiseTiltDown(data, A, width, channels, margin);
	reduceNoiseX(data, A, width, channels, margin);
	reduceNoiseY(data, A, width, channels, margin);


	if (context) drawPixels(data, A, width, channels, 50, 10);

	findObjects(config.minimumSize, config.maximumSize, config.AABBverticalRatioMin, config.AABBverticalRatioMax, A, data, digitObjects, width, channels, eliminatedPixels, true);
	//if (context) showEliminated(eliminatedPixels, width, channels);
	if (consoleDebug) console.log("digitObjects count before filters: " + digitObjects.length);
	/*if (context) {
		if (digitObjects) {
			drawAABBs(digitObjects, "red");
		}

	}*/
	displacementFilter(digitObjects, config.YDisplacementMax, 3);
	if (consoleDebug) console.log("Meters count after Y placement filter : " + digitObjects.length);
	heightVarianceFilter2(digitObjects, config.maxHeightVariance, 4);
	if (consoleDebug) console.log("Meters count after height variance filter : " + digitObjects.length);
	neighbourFilter(digitObjects, config.neighbourMinDistance, config.neighbourMaxDistance, config.YDisplacementMax);
	if (consoleDebug) console.log("Meters count after neighbour filter : " + digitObjects.length);
	if (digitObjects.length < 5 && consoleDebug)console.log("-----------------NOT ENOUGH OBJECTS AFTER EARLY FILTERS------------------");
	//digitDetectionFilter(digitObjects, pixels);
	digitDetectionFilter(digitObjects, pixels, config2);

	spacingFilter(digitObjects, config.neighbourMinDistance, config.YDisplacementMax);
	if (consoleDebug) console.log("Meters count after spacing filter : " + digitObjects.length);
	/*
	if (context) {
		if (digitObjects) {
			drawAABBs(digitObjects, "orange");
		}

	} */

	var groups = groupingFilter(digitObjects, config.YDisplacementMax, 3);
	if (groups == -1) {
		if (consoleDebug) console.log("NO GROUPS FOUND!");
		return -1;
	}
	if (consoleDebug) console.log("groups found : " + groups.length);
	for (var i = 0; i < groups.length; i++) {
		var groupObjects = groups[i];
		if (consoleDebug) console.log("Meters count in group : " + groupObjects.length);
		spacingVarianceFilter(groupObjects, 10);
		if (consoleDebug) console.log("Meters count after spacing variance filter : " + groupObjects.length);
		//heightVarianceFilter2(groupObjects, config.maxHeightVariance);

		if (consoleDebug) console.log("Meters count after height variance 2 filter : " + groupObjects.length);

		if (groupObjects.length > 5) checkEdgeObjects(groupObjects);

		if (consoleDebug) console.log("Meters count after edge object filter : " + groupObjects.length);


		gapFilter(groupObjects, 60); // 60 is max gap
		if (consoleDebug) console.log("Meters count after gap filter : " + groupObjects.length);

		groupObjects = groupValidationFilter(groupObjects);

		if (groupObjects.length < 4) {
			groups.splice(i, 1);
			i--;
		}
	}
	if (groups.length == 0) {
		if (consoleDebug) console.log("NO GROUPS FOUND!");
		return -1;
	}

	/*
	for (var i = 0; i < digitObjects.length; i++) {
		var digit = digitObjects[i];
		var result = digitDetection(digit, config.AABBRatioForDigit1, [digit.AABB[0] - 4,digit.AABB[1] - 4 , digit.AABB[2] + 4, digit.AABB[3] + 4], data, width, channels, false);
		if (consoleDebug) console.log(result);

	}
	*/

	//if (context) context.putImageData(sourceImageData, 400, 0, img_area[0], img_area[1], img_area[2], img_area[3]);

	if (consoleDebug) {
		console.log("Time : " + (new Date().getTime() - startTime));
	}
	if (consoleDebug) {
		console.log("groups total : " + groups.length);
	}
	/*
	if (context) {
		//groups[0].splice(3,1);
		if (groups[0]) {
			drawAABBs(groups[0], "yellow");
			if (consoleDebug) console.log("yellow group total : " +groups[0].length);
		}
		if (groups[1]) {
			drawAABBs(groups[1], "pink");
			if (consoleDebug) console.log("pink group total : " +groups[1].length);
		}
	} */

	if (debugDiv && canvas) {
		var test = document.getElementById("targetCanvas");
		if (test) debugDiv.removeChild(test);
		debugDiv.appendChild(canvas);

	}

	// Use the group with most numbers
	if (groups.length > 1) {
		groups.sort(function(a, b){ // Sort by length
				var x1 = a.length, x2 = b.length;
				if (x1 > x2) return 1;
				if (x1 < x2) return -1;
				return 0;
			});
	}

	var results = getCenters(groups[groups.length - 1]);
	var avgW = getAverageWidth(groups[groups.length - 1]);
	var avgH = getAverageHeight(groups[groups.length - 1]);
	var borders = getBorders(results, avgW, avgH);
	//digitDetectionFilter(borders, pixels, config2);

	if (checkOverlap(borders)) {
		if (consoleDebug) console.log("Digit areas overlap!");
		return -1;
	}

	if (context) {
		if (borders) {
			drawAABBs(borders, "pink");
		}
	}

	if (borders.length == 4) {
		// Check if moving number on right side by finding objects from estimated digit area
		var objs = [];
		var gap = borders[1].x - borders[0].x;
		var testArea = [borders[3].AABB[0] + gap, borders[3].AABB[1], borders[3].AABB[2] + gap, borders[3].AABB[3]];
		eliminatedPixels = [];
		findObjects(config.minimumSize, config.maximumSize, .5, config.AABBverticalRatioMax, testArea, data, objs, width, channels, eliminatedPixels, false);
		if (objs.length > 0 ) {
			objs.sort(function(a, b){ // Sorts objects based on size
				var x1 = a.edgePoints, x2 = b.edgePoints;
				if (x1 > x2) return 1;
				if (x1 < x2) return -1;
				return 0;
			});
			// Check size of largest object relative to borders
			if (objs[0].w > .2 * (testArea[2] - testArea[0]) || objs[0].h > .3 * (testArea[3] - testArea[1])) {
				borders.push({x: borders[3].x + gap, y: borders[3].y, AABB: testArea});
			}
		}
	}

	if (consoleDebug) console.log(results);
	return borders;
}

// function is exposed outside this file with module.exports
module.exports.findDigits = find;
module.exports.findDigitsFromFile = findFromFile;

function digitDetectionFilter(objects, pixelsObject, config){
	if (!objects) return false;
	if (!objects[0]) return false;
	if (objects.length == 0) return false;
	var options = {};
	options.digits = [];
	options.digits = {};
	options.digits.positions = [];

	for (var i = 0; i < objects.length; i++) {
		var obj = objects[i];
		obj.digit = -99;
		options.digits.positions[i] = {};
		var padding = 0;
		options.digits.positions[i].coords = [obj.AABB[0] - padding, obj.AABB[1] + padding, obj.AABB[2] + padding, obj.AABB[3] + padding];
		//console.log("AABB " + obj.AABB[0] + " " + obj.AABB[1] + " " + obj.AABB[2] + " " + obj.AABB[3]);


		// If Digit is detected and it's not number 1, use width as target width. Anything wider will be dropped and anything narrower
		// that's not number 1 will be dropped as well
		// Record the number of detections inside a group. Group with most numbers win.
		// Anytime you need to decide between two objects choose the one that is a number

	}
	var result = digitreader.analyzeImage(pixelsObject, /*config*/options, null, null);
		//console.log("DIGIT DETECTION RETURNED "+result.digits[0].result);

		//obj.digit = result.digits[0].result;
		//if (obj.digit >= 0)

		if (result) {
			for (var i = 0; i < result.digits.length; i++){
				var obj = objects[i];
				obj.digit = result.digits[i].result;
				if (consoleDebug) console.log("-->Digit result :" + result.digits[i].result);
			}
		}

}
function checkOverlap(objects){
	for (var i = 0; i < objects.length - 1; i++) {
			if (objects[i].AABB[2] > objects[i + 1].AABB[0]) return true;
	}
	return false;
}

function getBorders(objects, avgW, avgH){
	var padding = 4;
	var borders = [];
	for (var i = 0; i < objects.length; i++) {
		var centerX = objects[i][0];
		var centerY = objects[i][1];
		var obj = {};
		obj.x = centerX;
		obj.y = centerY;
		obj.AABB = [centerX - Math.floor(avgW / 2) - padding,
					centerY - Math.floor(avgH / 2) - padding - 1,
					centerX + Math.floor(avgW / 2) + padding,
					centerY + Math.floor(avgH / 2) + padding + 1];
		borders.push(obj);
	}
	return borders;
}

function getCenters(objects){
	if (objects.length < 4) return -1;
	var avg = 0;

	objects.sort(function(a, b){ // Sorts points based on center y
			var x1 = a.center.y, x2 = b.center.y;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
 	// Remove smallest and largest height from average
	for (var i = 1; i < objects.length - 1; i++) {
		avg += objects[i].center.y;
	}
	avg /= objects.length - 2;
	objects.sort(function(a, b){ // Sorts points based on center x
			var x1 = a.center.x, x2 = b.center.x;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
	var centers = [];
	for (var i = 0; i < objects.length; i++) {
		centers.push([objects[i].center.x, Math.floor(avg)]);
	}
	return centers;
}

function getAverageHeight(objects){
	if (objects.length < 4) return -1;
	var avg = 0;

	objects.sort(function(a, b){ // Sorts points based on height
			var x1 = a.h, x2 = b.h;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
 	// Remove smallest and largest height from average
	for (var i = 1; i < objects.length - 1; i++) {
		avg += objects[i].h;
	}
	avg /= objects.length - 2;
	return avg;
}

function getAverageWidth(objects){
	if (objects.length < 4) return -1;
	var avg = 0;

	objects.sort(function(a, b){ // Sorts points based on width
			var x1 = a.w, x2 = b.w;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
	var oneCount = 0;
 	// Remove smallest and largest width from average
	for (var i = 1; i < objects.length - 1; i++) {
		if(objects[i].h / objects[i].w > 3) oneCount++;
		else avg += objects[i].w;
	}

	if (avg == 0) return Math.floor(objects[Math.floor(objects.length / 2)].w * 2.5);
	avg /= objects.length - 2 - oneCount;
	return avg;
}

function groupValidationFilter(objects){
	// check for equal spacing
	if (objects.length < 4) {
		return [];
	}
	objects.sort(function(a, b){ // Sort left to right
			var x1 = a.center.x, x2 = b.center.x;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
	var firstDistance = objects[1].center.x - objects[0].center.x;
	for (var i = 1; i < objects.length - 1; i++) {
		var distance = objects[i + 1].center.x - objects[i].center.x;
		if ( distance > firstDistance + 8 || distance < firstDistance - 8) {
			return [];

		}
	}
	return objects;
}

function displacementFilter(objects, yRange, minCount){
	if (objects.length < 2) return -1;
	for (var i = 0; i < objects.length; i++) {
		var obj1 = objects[i];
		var neighbours = 0;
		for (var ii = 0; ii < objects.length; ii++) {
			if (i == ii) continue;
			var obj2 = objects[ii];
			var distance = Math.abs(obj1.center.y - obj2.center.y);
			if (distance < yRange) neighbours++;
		}
		if (neighbours < minCount) { objects.splice(i, 1); i--;}
	}
}

function heightVarianceFilter(objects, yRange, minCount){
	for (var i = 0; i < objects.length; i++) {
		var obj1 = objects[i];
		var neighbours = 0;
		for (var ii = 0; ii < objects.length; ii++) {
			if (i == ii) continue;
			var obj2 = objects[ii];
			var distance = Math.abs(obj1.h - obj2.h);
			if (distance < yRange) neighbours++;
		}
		if (neighbours < minCount) { objects.splice(i, 1); i--;}
	}
}

function heightVarianceFilter2(objects, yRange){
	if (objects.length < 2) return -1;
	// find average height
	var avg = 0;
	objects.sort(function(a, b){ // Sorts points based on height
			var x1 = a.h, x2 = b.h;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
 	// Remove smallest and largest height from average
	for (var i = 1; i < objects.length - 1; i++) {
		avg += objects[i].h;
	}
	avg /= objects.length - 2;
	// remove objects that have wrong variance
	for (var i = 0; i < objects.length; i++) {
		if (Math.abs(objects[i].h - avg) > avg * .4) {
			objects.splice(i, 1);
			i--;
		}
	}
}

function checkEdgeObjects(objects){
	if (objects.length < 2) return -1;
	objects.sort(function(a, b){ // Sorts based on height
			var x1 = a.h, x2 = b.h;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
	var minH = objects[0].h;
	var minHGap = objects[1].h - objects[0].h;
	var maxH = objects[objects.length - 1].h;
	var maxHGap = objects[objects.length - 1].h - objects[objects.length - 2].h;

	objects.sort(function(a, b){ // Sorts based on width
			var x1 = a.w, x2 = b.w;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
	var minW = objects[0].w;
	var minWGap = objects[1].w - objects[0].w;
	var maxW = objects[objects.length - 1].w;
	var maxWGap = objects[objects.length - 1].w - objects[objects.length - 2].w;

	objects.sort(function(a, b){ // Sorts from left to right
			var x1 = a.center.x, x2 = b.center.x;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});

	if ((objects[0].w == minW && minWGap > 2)|| (objects[0].h == minH && minHGap > 1) || (objects[0].h == maxH && maxHGap > 2)) objects.splice(0, 1);

	// Check that last object is not the smallest if object is close to center
	if (objects[objects.length - 1].h == minH && minHGap > 2 && objects[objects.length - 1].digit < 0) objects.splice(objects.length - 1, 1);



	//var avgH = getAverageHeight(groups[groups.length - 1]);



}

function neighbourFilter(objects, minDistance, maxDistance, yRange){
	if (objects.length < 2) return -1;
	for (var i = 0; i < objects.length; i++) {
		var obj1 = objects[i];
		var neighbours = 0;
		for (var ii = 0; ii < objects.length; ii++) {
			if (i == ii) continue;
			var obj2 = objects[ii];
			var distance = Math.abs(obj1.center.x - obj2.center.x);
			var distance2 = Math.abs(obj1.center.y - obj2.center.y);
			if (distance > minDistance && distance < maxDistance && distance2 < yRange) neighbours++;
		}
		if (neighbours == 0) { objects.splice(i, 1); i--;}
	}
}

function spacingFilter(objects, minDistance, yRange){
	if (objects.length < 2) return -1;
	objects.sort(function(a, b){ // Sorts objects from left to right
			var x1 = a.center.x, x2 = b.center.x;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});

	for (var i = 0; i < objects.length; i++) {
		var obj1 = objects[i];
		if (!obj1) continue;
		for (var ii = 0; ii < objects.length; ii++) {
			if (i == ii) continue;
			var obj2 = objects[ii];
			if (!obj2) continue;
			var distance = Math.abs(obj1.center.x - obj2.center.x);
			var distance2 = Math.abs(obj1.center.y - obj2.center.y);
			var gap = Math.abs(obj1.AABB[2] - obj2.AABB[0]);
			if ((distance < minDistance || (gap < 14 && obj1.w < 35 && obj2.w < 35))&& distance2 < yRange){

				//if ((obj1.w > obj2.w || obj1.h > obj2.h) || distance > minDistance * .5) {

				if ((obj1.digit == 0 || obj1.digit > 1) && (obj2.digit != 0 && obj2.digit < 2)) {
					//console.log("---------------------------- SPLICE ii -------------------------");
					objects.splice(ii, 1);
					ii--;
					continue;
				}
				if ((obj2.digit == 0 || obj2.digit > 1) && (obj1.digit != 0 && obj1.digit < 2)) {
					objects.splice(i, 1);
					//console.log("---------------------------- SPLICE i -------------------------");
					i--;
					continue;
				}

				// Removes blocks on right side of numbers

				if (obj1.AABB[2] < obj2.AABB[0] && obj1.h < obj2.h * 1.2) {
					objects.splice(ii, 1);
					ii--;
					continue;
				}


				if (obj1.AABB[0] <= obj2.AABB[0] && distance < 12 && (obj1.AABB[3] >= obj2.AABB[3] || obj1.w < obj2.w) && (obj1.AABB[1] < obj2.AABB[1] || (obj1.AABB[2] > obj2.AABB[2]))) {
					objects.splice(i, 1);
					i--;
				} else {
					if (obj1.w < obj2.w && obj1.AABB[0] <= obj2.AABB[0] && (obj1.digit < 0 || obj1.digit == 1)) {
						objects.splice(i, 1);
						i--;
					} else if (obj2.digit < 0 || obj2.digit == 1) { // We don't want to remove a number
						objects.splice(ii, 1);
						ii--;
					}
				}
			}
		}
	}
}

function groupingFilter(objects, yRange, minCount){

	if (objects.length < 2) return -1;
	var groups = [];
	objects.sort(function(a, b){ // Sorts points from top to bottom and left to right
			var y1 = a.center.y, y2 = b.center.y;
			if (y1 > y2) return 1;
			if (y1 < y2) return -1;
			var x1 = a.center.x, x2 = b.center.x;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
	//if (consoleDebug) console.log(objects);
	// Start grouping

	for (var i = 1, distance = 0, minY = objects[0].center.y, minI = 0, members = 1; i < objects.length; i++) {
		var obj1 = objects[i];
		if (obj1.center.y - minY < yRange && i != objects.length - 1) {
			members++;
		} else {
			var addLast = 0;
			if (obj1.center.y - minY  < yRange) {
				members++; // Need to add last member also if suitable
				addLast = 1;
			}
			if (members < minCount) {
				objects.splice(minI, i - minI);
				i = minI;
				minY = objects[i].center.y;
				members = 1;
			} else { // Approve the group?
				//objects.splice(i + 1, objects.length - i - 1);
				if (consoleDebug) console.log("members " + members);
				var group = objects.slice(minI, i + addLast);
				groups.push(group);
				//break;
				minI = i;
				minY = objects[minI].center.y;
				members = 1;
			}
		}
	}

	return groups;
}

function spacingVarianceFilter(objects, maxVariance){
	objects.sort(function(a, b){ // Sorts points from left to right
			var x1 = a.center.x, x2 = b.center.x;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});

	if (objects.length < 2) return -1;
	// Calculate variances for each object
	for (var i = 0; i < objects.length; i++) {
		if (!objects[i]) continue;
		if (i == 0) objects[i].spacingVariance = objects[i + 1].center.x - objects[i].center.x;
		else if (i == objects.length - 1) objects[i].spacingVariance = objects[i].center.x - objects[i - 1].center.x;
		else {
			var variance1 = objects[i + 1].center.x - objects[i].center.x;
			var variance2 = objects[i].center.x - objects[i - 1].center.x;
			if (Math.abs(variance1 - variance2) < 4) objects[i].spacingVariance = Math.floor(((objects[i + 1].center.x - objects[i].center.x) + (objects[i].center.x - objects[i - 1].center.x)) / 2);
			else if (variance1 > variance2) objects[i].spacingVariance = variance2; // Choose the smaller variance if variance vary a lot
			else objects[i].spacingVariance = variance1;
		}
	}
	// find average variance
	var avg = 0;

	objects.sort(function(a, b){ // Sorts points based on variance
			var x1 = a.spacingVariance, x2 = b.spacingVariance;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
 	// Remove smallest and largest variance from average
	for (var i = 1; i < objects.length - 1; i++) {
		avg += objects[i].spacingVariance;
	}
	avg /= (objects.length - 2);
	//console.log(objects);
	//console.log("avg : " + avg);
	// remove objects that have wrong variance
	for (var i = 0; i < objects.length; i++) {
		if (Math.abs(objects[i].spacingVariance - avg) > maxVariance) {
			objects.splice(i, 1);
			i--;
		}
	}


}

function gapFilter(objects, maxGap){
	if (objects.length < 2) return -1;
	objects.sort(function(a, b){ // Sorts points from left to right
			var x1 = a.center.x, x2 = b.center.x;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});

	for (var i = 0; i < objects.length; i++) {
		if (i != objects.length - 1) objects[i].gap = objects[i + 1].center.x - objects[i].center.x;
		else objects[i].gap = 999;
		if (objects[i].gap > maxGap) { // If there is a big cap destroy remaining objects
			objects.splice(i + 1, objects.length - i - 1);
			break;
		}
	}

	objects.sort(function(a, b){ // Sorts points based on gap
			var x1 = a.gap, x2 = b.gap;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
	// Use the middle object gap as it should be better than average
	var avg = objects[Math.floor(objects.length / 2)].gap;

	objects.sort(function(a, b){ // Sorts points from left to right
			var x1 = a.center.x, x2 = b.center.x;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});

	for (var i = 0; i < objects.length - 1; i++) {
		if (Math.abs(objects[i].gap - avg) > 6) {
				if (i < objects.length / 2) objects.splice(0, i + 1);
				else objects.splice(i + 1, objects.length - i - 1);
		}
	}
}

function findObjects(minSize, maxSize, AABBverticalRatioMin, AABBverticalRatioMax, selectedArea, data, digitObjects, W, CH, eliminated, filter){

	for (var j = selectedArea[1]; j <= selectedArea[3]; j+=15){ // lines - start from left
		for (var i = selectedArea[0], index, oL, w, h, AABB, AABBRatio, center; i < selectedArea[2]; i++){ // rows
			index = i * CH + j * CH * W; // Position to index
			if (eliminated[index]) continue;
			if (data[index] > 0) {
				// We've found a possible object edge, try to get the outline
				var object = getOutlinePixels(index, selectedArea[0], selectedArea[1], selectedArea[2], selectedArea[3], false, data, W, CH, eliminated);
				// Check if the object passes simple filters
				if (!object) continue;
				oL = object.length;

				// Get AABB of object - Could we do this already during getOutlinePixels?
				var minX = 9999, maxX = 0, minY = 9999, maxY = 0; // Normal AABB
				for (var i2 = 0, pt, x, y; i2 < oL; i2++){
					pt = object[i2];
					x = pt >> 16;
					y = pt & 0xffff;
					if (x < minX) minX = x;
					if (x > maxX) maxX = x;
					if (y < minY) minY = y;
					if (y > maxY) maxY = y;
				}

				AABB = [minX, minY, maxX, maxY];
				w = AABB[2] - AABB[0];
				h = AABB[3] - AABB[1];
				AABBRatio = h / w;

				if (oL < minSize || oL > maxSize) {
					eliminateObjectArea(object, false, W, CH, eliminated, data);
					continue;
				}
				if (filter) {
					if (h < 24 || h > 50 || w < 3 || w > 45) {
						eliminateObjectArea(object, false, W, CH, eliminated, data);
						continue;
					}
				}

				// Validate that AABB has correct dimensions

				if (AABBverticalRatioMin) {
					if (AABBRatio < AABBverticalRatioMin) {
						eliminateObjectArea(object, false, W, CH, eliminated, data);
						continue;
					}
				}

				if (AABBverticalRatioMax) {
					if (AABBRatio > AABBverticalRatioMax) {
						eliminateObjectArea(object, false, W, CH, eliminated, data);
						continue;
					}
				}

				if (getAreaDensity(object, AABB, W, CH, data) > .8 && AABBRatio < 2) {
					eliminateObjectArea(object, false, W, CH, eliminated, data);
					continue;
				}

				center = {x: AABB[0] + (w >> 1), y: AABB[1] + (h >> 1)};

				eliminateObjectArea(object, false, W, CH, eliminated, data);
				digitObjects.push({id: index, value: 1, center: center, edgePoints: oL, AABB: AABB, points : object, w: w, h: h});
			}
		}
	}
}

function findInvertedObjects(minSize, maxSize, selectedArea, data, W, CH){
	var eliminated = [];
	var invertedObjects = [];
	for (var j = selectedArea[1]; j <= selectedArea[3]; j++){ // lines
		for (var i = selectedArea[0], index, object, w, h, AABB, center, result, invertedObject; i < selectedArea[2]; i++){ // rows
			index = i * CH + j * CH * W; // Position to index
			if (eliminated[index]) continue;
			if (data[index] == 0) { // Looking for zeros this time
				// We've found a possible object edge, try to get the outline
				object = getOutlinePixels(index, selectedArea[0], selectedArea[1], selectedArea[2], selectedArea[3], true, data, W, CH); // inverted
				if (!object) continue;
				// Get AABB of object - Could we do this already during getOutlinePixels?
				var minX = 9999, maxX = 0, minY = 9999, maxY = 0;
				for (var i2 = 0, l = object.length, pt, x, y; i2 < l; i2++){
					pt = object[i2];
					x = pt >> 16;
					y = pt & 0xffff;
					if (x < minX) minX = x;
					if (x > maxX) maxX = x;
					if (y < minY) minY = y;
					if (y > maxY) maxY = y;
				}
				AABB = [minX, minY, maxX, maxY];
				w = AABB[2] - AABB[0];
				h = AABB[3] - AABB[1];
				center = {x: AABB[0] + (w >> 1), y: AABB[1] + (h >> 1)};
				var invertedObject = {id: index, value: 1, center: center, edgePoints: object.length, AABB: AABB, points : object, w: w, h: h};
				eliminateObjectArea(object, true, W, CH, eliminated, data);
				if (object.length >= minSize && object.length <= maxSize) invertedObjects.push(invertedObject);
				//if (context) drawOutline(object, data);
			}
		}
	}
	//if (consoleDebug) console.log(invertedObjects);
	return invertedObjects;
}


function getOutlinePixels(p, minX, minY, maxX, maxY, inverted, data, W, CH, eliminated){
	var max = 9000; // To avoid endless loop
	var maxCounter = 0;
	var outline = [];
	var firstP = p;
	var x = p / CH % W;
	var y =  p / CH / W | 0;
	outline.push(x << 16 | y); // We already got the first pixel
	var backtrack = 7; // Assumed backtrack direction - left
	var neighbors = [];
	var nIndex;
	var counter;
	while (1) {
		maxCounter ++;
		neighbors[0] = p - CH - CH * W;
		neighbors[1] = p - CH * W;
		neighbors[2] = p + CH - CH * W;
		neighbors[3] = p + CH;
		neighbors[4] = p + CH + CH * W;
		neighbors[5] = p + CH * W;
		neighbors[6] = p - CH + CH * W;
		neighbors[7] = p - CH;

		nIndex = backtrack + 1;
		if (nIndex > 7) nIndex = 0;
		counter = 0;
		while (counter < 8) {
			if(!eliminated[neighbors[nIndex]] && ((!inverted && data[neighbors[nIndex]] > 0) || (inverted && data[neighbors[nIndex]] == 0))) {
				p = neighbors[nIndex];
				x = p / CH % W;
				y = p / CH / W | 0;
				if (x > minX && x < maxX && y > minY && y < maxY) {
					outline.push(x << 16 | y);
					if (nIndex < 4) backtrack = nIndex + 4; else backtrack = nIndex - 4;
					break;
				}
			}
			nIndex ++;
			counter ++;
			if (nIndex > 7) nIndex = 0;
		}
		if (counter > 7) break; // Exit if no matches found
		if (p == firstP) break; // Exit when first pixel reached again
		if (maxCounter > max) break; // We need to give up to avoid endless loop
	}
	return outline;
}


function removeHorizontalLines(minW, selectedArea, data, W, CH) {

	for (var j = selectedArea[1]; j <= selectedArea[3]; j++){ // y
		var wCounter = 0;
		for (var i = selectedArea[0], index; i < selectedArea[2]; i++){ // x
			index = i * CH + j * CH * W; // Position to index
			if (data[index] > 0) { // Is pixel set
				wCounter ++;
			}
			else if (wCounter >= minW) {
				// unset pixels
				for (var i2 = index - wCounter * 4; i2 <= index; i2 += 4) {
					data[i2] = 0;
				}
				wCounter = 0;
			} else {
				wCounter = 0;
			}
			if (i == selectedArea[2] - 1 && wCounter >= minW) { // last pixel of the row
				// unset pixels
				for (var i2 = index - wCounter * 4; i2 <= index; i2 += 4) {
					data[i2] = 0;
				}
			}
		}
	}


}


function eliminateObjectArea(pts, inverted, W, CH, eliminated, data){
	var l = pts.length;
	pts.sort(function(a, b){ // Sorts points from top to bottom and left to right
			var y1 = a & 0xffff, y2 = b & 0xffff;
			if (y1 > y2) return 1;
			if (y1 < y2) return -1;
			var x1 = a >> 16, x2 = b >> 16;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});

	for (var i = 0, w, x, x2, y, y2, pt, pt2; i < l; i++) {
		pt = pts[i];
		x = pt >> 16;
		y = pt & 0xffff;
		if (i != l - 1) {
			pt2 = pts[i + 1];
			x2 = pt2 >> 16;
			y2 = pt2 & 0xffff;
		} else { // last point is a single pixel spot
			y2 = -1;
		}

		if (y == y2) { // we have two successive points with same y coordinate
			for (var j = x; j <= x2; j++) {
				var pi = j * CH + y * CH * W;
				if (data[pi] == 0) break;
				eliminated[pi] = true;
			}
			for (var j = x2; j >= x; j--) {
				var pi = j * CH + y * CH * W;
				if (data[pi] == 0) break;
				eliminated[pi] = true;
			}
			i++; // skip the next point as it is our right edge
		} else {
			var pi = x * CH + y * CH * W;
			eliminated[pi] = true;
		}
	}
}


// MORE HELPER FUNCTIONS

function localContrastNormalization(invert, size, data, imgArea, threshold, W, CH){
	var xEnd = imgArea[2],
		yEnd = imgArea[3];
	var divisor = 1 / ((size) * (size) - 1);
	for (var y = imgArea[1]; y <= yEnd; y++){
		for (var x = imgArea[0], neighbors, sum, l, avg, i, x2, y2; x < xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			sum = 0;
			for (var jj = 0; jj < size; jj += 1){ // lines
				for (var ii = 0, x, y, index; ii < size; ii += 1){ // rows
					x2 = x + ii - (size >> 1);
					y2 = y + jj - (size >> 1);
					if (x2 == x && y2 == y) continue; // don't include yourself
					sum += data[x2 * CH + y2 * CH * W + 2];
				}
			}
			avg = sum * divisor;
			if (invert) {
				if (data[i + 2] > avg + avg * threshold) data[i] = 255;
				else data[i] = 0;

			} else {
				if (data[i + 2] < avg - avg * threshold) data[i] = 255;
				else data[i] = 0;
			}
		}
	}
}


function calculateLuminance(data, imgArea, W, CH) { // Use imgArea to limit area
	var floor = Math.floor;
	var xEnd = imgArea[0] + imgArea[2],
		yEnd = imgArea[1] + imgArea[3];
	for (var y = imgArea[1], r, g, b, lum; y <= yEnd; y++){ // lines
		for (var x = imgArea[0], i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			r = data[i], g = data[++i], b = data[++i];
			data[i] = (r + r + b + g + g + g) / 6 | 0;
		}
	}
}


function invertData(src, imgArea, W, CH) {
	var xEnd = imgArea[2],
		yEnd = imgArea[3];
	for (var y = imgArea[1]; y <= yEnd; y++){ // lines
		for (var x = imgArea[0], i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			if (src[i] == 0) src[i] = 255;
			else if (src[i] == 255) src[i] = 0;
		}
    }
}

function reduceNoiseX(src, imgArea, W, CH, margin) {
	var xStart = imgArea[0],
		yStart = imgArea[1],
		xEnd = imgArea[2],
		yEnd = imgArea[3];
	var width = xEnd - xStart;
	var height = yEnd - yStart;
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i, pI, nI; x <= xEnd; x++){ // rows
			if (margin && (x > xStart + width * margin) && (x < xEnd - width * margin) && y > (yStart + height * margin) && y < (yEnd - height * margin)) continue;
			i = x * CH + y * CH * W; // Position to index
			if (x == xEnd) nI = i;  // Next position
			else  nI = (x + 1) * CH + y * CH * W;
			if (x > xStart) pI = (x - 1) * CH + y * CH * W; // Previous position
			else pI = i;
			//if (src[i] != src[pI] && src[i] != src[nI]) src[i] = Math.abs(src[i] - 255);
			if (src[i] == 255 && src[i] != src[pI] && src[i] != src[nI]) src[i] = 0;
		}
    }
}

function reduceNoiseY(src, imgArea, W, CH, margin) {
	var xStart = imgArea[0],
		yStart = imgArea[1],
		xEnd = imgArea[2],
		yEnd = imgArea[3];
	var width = xEnd - xStart;
	var height = yEnd - yStart;
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i, pI, nI; x <= xEnd; x++){ // rows
			if (margin && (x > xStart + width * margin) && (x < xEnd - width * margin) && y > (yStart + height * margin) && y < (yEnd - height * margin)) continue;
			i = x * CH + y * CH * W; // Position to index
			if (y == yEnd) nI = i;  // Next position
			else  nI = x * CH + (y + 1) * CH * W;
			if (y > yStart) pI = x * CH + (y - 1) * CH * W; // Previous position
			else pI = i;
			//if (src[i] != src[pI] && src[i] != src[nI]) src[i] = Math.abs(src[i] - 255);
			if (src[i] == 255 && src[i] != src[pI] && src[i] != src[nI]) src[i] = 0;
		}
    }
}

function reduceNoiseTiltUp(src, imgArea, W, CH, margin) {
	var xStart = imgArea[0],
		yStart = imgArea[1],
		xEnd = imgArea[2],
		yEnd = imgArea[3];
	var width = xEnd - xStart;
	var height = yEnd - yStart;
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i, pI, nI; x <= xEnd; x++){ // rows
			if (margin && (x > xStart + width * margin) && (x < xEnd - width * margin) && y > (yStart + height * margin) && y < (yEnd - height * margin)) continue;
			i = x * CH + y * CH * W; // Position to index
			if (y == yStart || x == xEnd) nI = i;  // Next position
			else  nI = (x + 1) * CH + (y - 1) * CH * W;
			if (y == yEnd || x == xStart) pI = i;
			else pI = (x - 1) * CH + (y + 1) * CH * W; // Previous position
			//if (src[i] != src[pI] && src[i] != src[nI]) src[i] = Math.abs(src[i] - 255);
			if (src[i] == 255 && src[i] != src[pI] && src[i] != src[nI]) src[i] = 0;
		}
    }
}

function reduceNoiseTiltDown(src, imgArea, W, CH, margin) {
	var xStart = imgArea[0],
		yStart = imgArea[1],
		xEnd = imgArea[2],
		yEnd = imgArea[3];
	var width = xEnd - xStart;
	var height = yEnd - yStart;
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i, pI, nI; x <= xEnd; x++){ // rows
			if (margin && (x > xStart + width * margin) && (x < xEnd - width * margin) && y > (yStart + height * margin) && y < (yEnd - height * margin)) continue;
			i = x * CH + y * CH * W; // Position to index
			if (y == yEnd || x == xEnd) nI = i;  // Next position
			else  nI = (x + 1) * CH + (y + 1) * CH * W;
			if (y == yStart || x == xStart) pI = i;
			else pI = (x - 1) * CH + (y -1) * CH * W; // Previous position
			//if (src[i] != src[pI] && src[i] != src[nI]) src[i] = Math.abs(src[i] - 255);
			if (src[i] == 255 && src[i] != src[pI] && src[i] != src[nI]) src[i] = 0;
		}
    }
}

function kuwaharaFilter(src, imgArea, W, H, CH, kernelSize) {
	var areaW = (kernelSize + 1) / 2;
	var offset = (kernelSize - 1) / 2;
	var xStart = imgArea[0],
	yStart = imgArea[1],
	xEnd = imgArea[2],
	yEnd = imgArea[3];
	if (context) var imgData2 = context.createImageData(xEnd - xStart, yEnd - yStart);
	var buf = [];

	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			var color = src[i];
			// Create corner areas
			var x1 = x - offset;
			if (x1 < xStart) x1 = xStart;
			var x2 = x;
			if (x2 > xEnd) x2 = xEnd;
			var y1 = y - offset;
			if (y1 < yStart) y1 = yStart;
			var y2 = y;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			x1 = x;
			if (x1 < xStart) x1 = xStart;
			x2 = x + offset;
			if (x2 > xEnd) x2 = xEnd;
			y1 = y - offset;
			if (y1 < yStart) y1 = yStart;
			y2 = y;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance2 = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			if (areaVariance2[0] < areaVariance[0]) areaVariance = areaVariance2;
			x1 = x;
			if (x1 < xStart) x1 = xStart;
			x2 = x + offset;
			if (x2 > xEnd) x2 = xEnd;
			y1 = y;
			if (y1 < yStart) y1 = yStart;
			y2 = y + offset;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance3 = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			if (areaVariance3[0] < areaVariance[0]) areaVariance = areaVariance3;
			x1 = x - offset;
			if (x1 < xStart) x1 = xStart;
			x2 = x;
			if (x2 > xEnd) x2 = xEnd;
			y1 = y;
			if (y1 < yStart) y1 = yStart;
			y2 = y + offset;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance4 = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			if (areaVariance4[0] < areaVariance[0]) areaVariance = areaVariance4;
			//src[i] = areaVariance[1]; // Set value to the mean of area with least variance
			var i2 = (x - xStart) * CH + (y - yStart) * CH * (xEnd - xStart); // Position to index
			//var i2 = i; // Position to index
			buf[i] = areaVariance[1]| 0;
			/*
			imgData.data[i] = areaVariance[1]| 0;
			imgData.data[i+1] = areaVariance[1]| 0;
			imgData.data[i+2] = areaVariance[1]| 0;
			imgData.data[i+3] = 255; */
			if (context) {
				imgData2.data[i2] = areaVariance[1]| 0;
				imgData2.data[i2+1] = areaVariance[1]| 0;
				imgData2.data[i2+2] = areaVariance[1]| 0;
				imgData2.data[i2+3] = 255;
			}
			//imgData2.data[i2] = imgData.data[i];
			//imgData2.data[i2+1] = imgData.data[i+1];
			//imgData2.data[i2+2] = imgData.data[i+2] 0;
			//imgData2.data[i2+3] = 255;
		}
    }
	//if (context) context.putImageData(imgData2, 10, 300);
	// Copy buf to image data
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			src[i] = buf[i];
			src[i+1] = buf[i];
			src[i+2] = buf[i];
			src[i+3] = 255;
		}
	}
	//src.set(imgData.data);
}

function getAreaData(src, x1, y1, x2, y2, W, CH){
	var data = [];
	for (var y = y1; y <= y2; y++){ // lines
		for (var x = x1, i; x <= x2; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			data.push(src[i]);
		}
	}
	return data;
}

function getAverage(data){
	var i = data.length, sum = 0;
	while( i-- ){ sum += data[i]; }
	return sum / data.length;
}

function getVariance(data){
	var i = data.length, v = 0;
	if (i < 2) {
		return [9999999999999, 0];
	}
	var avg = getAverage(data);
	while(i--){
		v += Math.pow( (data[ i ] - avg), 2 );
	}
	return [v / data.length, avg];
}

function getPixelBuffer(pts){ // Uncompresses point array to [[x,y], [x2,y2]...] pixel array
	var buf = [];
	var l = pts.length;
	for (var i = 0, p, x, y; i < l; i++) {
		p = pts[i];
		x = p >> 16;
		y = p & 0xffff;
		buf.push([x, y]);
	}
	return buf;
}

function getCompressedBuffer(pts){ // Uncompresses point array to [[x,y], [x2,y2]...] pixel array
	var buf = [];
	var l = pts.length;
	for (var i = 0, p, x, y; i < l; i++) {
		p = pts[i];
		x = p[0];
		y = p[1];
		buf.push(x << 16 | y);
	}
	return buf;
}

function getAreaDensity(obj, AABB, width, channels, data){ //calculate how many active pixels are inside given box
	var x1 = AABB[0];
	var y1 = AABB[2];
	var x2 = AABB[1];
	var y2 = AABB[3];
	var w = x2 - x1;
	var h = y2 - y1;
	var total = 0;
	for (var j = 0; j < h; j++){ // lines
		for (var i = 0; i < w; i++){ // rows
			var x = x1 + i;
			var y = y1 + j;
			var index = ((width * y) + x) * channels;
			if (data[index] > 0) {
				total++;
			}
		}
	}
	return total / (w * h);
}

// DEBUG DRAWING FUNCTIONS



function drawPixels(src, imgArea, W, CH, posX, posY){
		var xEnd = imgArea[2],
		yEnd = imgArea[3];
		for (var y = imgArea[1]; y <= yEnd; y++){ // lines
			for (var x = imgArea[0], i, pI, nI; x < xEnd; x++){ // rows
				i = x * CH + y * CH * W; // Position to index
				context.fillStyle = "black";
				if (src[i] == 255) context.fillStyle = "blue";
				context.fillRect((x - imgArea[0]) * 1 + posX, (y - imgArea[1]) * 1 + posY , 1, 1);
			}
		}

}


function drawAABBs(objects, color){
	if(consoleDebug) console.log(objects);
	for (var i = 0; i < objects.length; i ++){
		var pts = objects[i].AABB;
		var w = pts[2] - pts[0];
		var h = pts[3] - pts[1];
		context.lineWidth = 1.5;
		context.globalAlpha = 1;
		context.strokeStyle = color;
		context.strokeRect(pts[0], pts[1], w, h);
		context.fillStyle = "white";
		if (objects[i].center) context.fillRect(objects[i].center.x - 1, objects[i].center.y - 1, 2, 2);
		context.globalAlpha = 1;
	}
}

function showEliminated(eliminatedPixels, width, channels){
	context.fillStyle = "orange";
	for (var i = 0, l = eliminatedPixels.length; i < l; i++) {
		var index = eliminatedPixels[i];
		if (index) {
			var x = (i / channels) % width;
			var y =  Math.floor((i / channels) / width);
			context.fillRect(x, y, 1, 1);
		}
	}
}

function drawInverted(inverted){
	for (var i = 0; i < inverted.length; i++) {
		var points = inverted[i].points;

		if (i == 0) context.fillStyle = "yellow";
		else if (i == 1) context.fillStyle = "pink";
		else if (i == 2) context.fillStyle = "blue";
		else context.fillStyle = "white";
		for (var j = 0; j < points.length; j++) {
			var y = points[j] & 0xffff;
			var x = points[j] >> 16;
			context.fillRect(x, y, 1, 1);
		}
	}
}





//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-find-digits/index.js
// module id = 848
// module chunks = 0